import React from 'react'
import { getStaticPath } from '../utils'


const componentStyle = {
  height: '40px', width: '40px',
  objectFit: 'cover', borderRadius: '50%', marginRight: '10px',
}

const CategoryListIcon = ({ category }) => <img
  style={componentStyle}
  src={category.icon ? getStaticPath(category.icon) : getStaticPath('/vendor/blankIcon.png')}
/>

export default CategoryListIcon
